import React, { useState, useEffect } from "react";
import { useForm, Controller } from "react-hook-form";
import dayjs from "dayjs";
import {
    Modal,
    Box,
    Grid,
    Typography,
    Radio,
    RadioGroup,
    FormControlLabel,
    Checkbox,
    TextField,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Backdrop,
    CircularProgress,
    Button,
} from "@mui/material";


// import { postDoctorDropdown, postshiftingNotessaveOrUpdate } from "../../services/Sample/AllNotesService";

import { Dropdown } from "@mui/base";
import CancelPresentationIconButton from "../../../../common/components/Buttons/CancelPresentationIconButton";
import SearchDropdown from "../../../../common/components/FormFields/searchDropdown";
import DatePickerField from "../../../../common/components/FormFields/DatePickerFieldNew";
import ConfirmationModal from "../../../../common/components/ConfirmationModal";
import { successAlert } from "../../../../common/components/Toasts/CustomToasts";
import InputField from "../../../../common/components/FormFields/InputField";
import TimePickerFieldNew from "../../../../common/components/FormFields/TimePickerFieldNew";
import { postDoctorDropdown, postshiftingNotessaveOrUpdate } from "../../../services/otDetailsServices/OtDetailsServices";

const ModalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "50%",
    maxHeight: "90vh",
    overflow: "auto",
    bgcolor: "background.paper",
    border: "1px solid gray",
    borderRadius: 2,
    boxShadow: 20,
    p: 3,
};

export default function ShiftingNotesModel(props) {
    console.log("ShiftingNotesModelShiftingNotesModel",props);
    

    const [openPost, setOpenPost] = useState(false);
    const [pendingData, setPendingData] = useState(null);
    const [dataResult, setDataResult] = useState([]);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [count, setCount] = useState(0);
    const [loading, setLoading] = useState(false);
    const [selectedRows, setSelectedRows] = useState([]);
    const [patientData, setPatientData] = useState({});
    const [doctorOptions, setDoctorOptions] = useState([]);
    const [surgeonOptions, setSurgeonOptions] = useState([]);
    const [anesthetistOptions, setAnesthetistOptions] = useState([]);
    const [handoverToOptions, setHandoverToOptions] = useState([]);
    const [handoverByOptions, setHandoverByOptions] = useState([]);
    const [isUpdate, setIsUpdate] = useState(false);

    const defaultValues = {
        aldreteScore: "",
        shiftOutOrder: null,
        anesthetist: null,
        remark: "",
        handoverTo: null,
        handoverBy: null,
        handoverTime: null,
        handoverDate: null,
    };

    const {
        control,
        handleSubmit,
        reset,
        watch,
        getValues,
    } = useForm({
        defaultValues,
    });

    const [patientShiftData, setPatientShiftData] = useState({
        condition: "",
        shiftCriteria: "",
        shiftedTo: "",
    });

    const handleOpenPost = () => {
        setOpenPost(true);
    };
    const handleClosePost = () => {
        setOpenPost(false);
    };

    const getSurgeonDropdown = async (value = "") => {
        console.log("API Value:", value);
        if (!value?.trim()) return;

        try {
            const response = await postDoctorDropdown(value);
            setSurgeonOptions(response?.data?.result || []);
        } catch (error) {
            console.log(error);
        }
    };

    const getAnesthetistDropdown = async (value = "") => {
        console.log("Anesthetist Value:", value);
        if (!value?.trim()) return;

        try {
            const response = await postDoctorDropdown(value);

            setAnesthetistOptions(response?.data?.result || []);
        } catch (error) {
            console.log(error);
        }
    };

    const getHandoverToDropdown = async (value = "") => {
        console.log("Handover To Value:", value);
        if (!value?.trim()) return;

        try {
            const response = await postDoctorDropdown(value);

            setHandoverToOptions(response?.data?.result || []);
        } catch (error) {
            console.log(error);
        }
    };

    const getHandoverByDropdown = async (value = "") => {
        console.log("Handover By Value:", value);
        if (!value?.trim()) return;

        try {
            const response = await postDoctorDropdown(value);

            setHandoverByOptions(response?.data?.result || []);
        } catch (error) {
            console.log(error);
        }
    };

    const handleSubmitClick = (data) => {
        setPendingData(data);
        setOpenPost(true);
    };

    const addRecord = async () => {
        setOpenPost(false);

        const timeObj = new Date(pendingData?.handoverTime);
        const dateObj = new Date(pendingData?.handoverDate);

        const payload = {
            id: isUpdate ? props.patientData?.id : null,
            admissionId: props?.admissionId||0,
            otHeaderId: props?.otHeaderId || 0,
            aldreteScore: pendingData?.aldreteScore || "",

            shiftOutOrderBySurgeon:
                pendingData?.shiftOutOrder?.id ||
                patientData?.shiftOutOrderBySurgeon ||
                0,

            anesthetist:
                pendingData?.anesthetist?.id ||
                patientData?.anesthetist ||
                0,

            handoverTo:
                pendingData?.handoverTo?.id ||
                patientData?.handoverTo ||
                0,

            handoverBy:
                pendingData?.handoverBy?.id ||
                patientData?.handoverBy ||
                0,
            handoverTime: `${String(timeObj.getHours()).padStart(2, "0")}:${String(
                timeObj.getMinutes()
            ).padStart(2, "0")}:${String(timeObj.getSeconds()).padStart(2, "0")}`,
            handoverDate: dateObj.toISOString().split("T")[0],

            remark: pendingData?.remark || "",

            ...(isUpdate
                ? {
                    updatedBy: 1,
                    updatedDateTime: new Date().toISOString(),
                }
                : {
                    addedBy: 1,
                    addedDateTime: new Date().toISOString(),
                    updatedBy: 1,
                    updatedDateTime: new Date().toISOString(),
                }),
        };
        console.log("postshiftingNotessaveOrUpdate",payload)
        
        

        const response = await postshiftingNotessaveOrUpdate(payload);

        if (response?.data?.statusCode === 200) {

            if (isUpdate) {
                successAlert("Shifting Notes updated successfully");
            } else {
                successAlert("Record Saved Successfully");
            }

            reset(defaultValues);
            // props.handleClose();
        }

    };

    useEffect(() => {
        if (props.patientData) {
            setPatientData(props.patientData);
        }
    }, [props.patientData]);

    useEffect(() => {
        if (props.patientData?.id > 0) {

            setIsUpdate(true);

            const parsedDate = props.patientData?.handoverDate
                ? new Date(props.patientData.handoverDate)
                : null;

            console.log("API Date =", props.patientData?.handoverDate);
            console.log("Parsed =", parsedDate);

            setSurgeonOptions([
                {
                    label: props.patientData.shiftOutOrderBySurgeon,
                    value: props.patientData.shiftOutOrderBySurgeon,
                },
            ]);

            setAnesthetistOptions([
                {
                    label: props.patientData.anesthetist,
                    value: props.patientData.anesthetist,
                },
            ]);

            setHandoverToOptions([
                {
                    label: props.patientData.handoverTo,
                    value: props.patientData.handoverTo,
                },
            ]);

            setHandoverByOptions([
                {
                    label: props.patientData.handoverBy,
                    value: props.patientData.handoverBy,
                },
            ]);

            reset({
                aldreteScore: props.patientData?.aldreteScore || "",
                remark: props.patientData?.remark || "",
                shiftOutOrder: {
                    id: props.patientData.shiftOutOrderBySurgeonId,
                    label: props.patientData.shiftOutOrderBySurgeon,
                    value: props.patientData.shiftOutOrderBySurgeon,
                },
                anesthetist: {
                    id: props.patientData.anesthetistId,
                    label: props.patientData.anesthetist,
                    value: props.patientData.anesthetist,
                },

                handoverTo: {
                    id: props.patientData.handoverToId,
                    label: props.patientData.handoverTo,
                    value: props.patientData.handoverTo,
                },

                handoverBy: {
                    id: props.patientData.handoverById,
                    label: props.patientData.handoverBy,
                    value: props.patientData.handoverBy,
                },

                handoverTime: props.patientData?.handoverTime
                    ? new Date(`2000-01-01T${props.patientData.handoverTime}`)
                    : null,

                handoverDate: parsedDate,
            });

        } else {

            setIsUpdate(false);
            reset(defaultValues);
        }
    }, [props.patientData]);

    return (
        <div>
            <Box
                sx={{
                    mt: 2,
                    p: 3,
                    border: "1px solid #ddd",
                    borderRadius: 2,
                    backgroundColor: "#fff",
                }}
            >

                <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 mb-4">

                    <div className="border rounded-md bg-white">
                        <div className="bg-[#adfde8] text-sm font-semibold px-4 py-2 rounded-t-md">
                            Patient Details
                        </div>
                        <div className="space-y-3 p-4">
                            <div className="grid grid-cols-[180px_20px_1fr] items-center gap-2">
                                <Typography fontWeight="600">
                                    Aldrete Score
                                </Typography>

                                <Typography>:</Typography>

                                <InputField
                                    control={control}
                                    label="Aldrete Score"
                                    name="aldreteScore"
                                    size="small"
                                    fullWidth
                                />
                            </div>

                            <div className="grid grid-cols-[180px_20px_1fr] items-center gap-2 py-1">
                                <Typography fontWeight="600">
                                    Shift Out Order By Surgeon
                                </Typography>

                                <Typography>:</Typography>

                                <SearchDropdown
                                    control={control}
                                    name="shiftOutOrder"
                                    label="Shift Out Order By Surgeon"
                                     placeholder="Shift Out Order By Surgeon"
                                    options={surgeonOptions}
                                    isClearable
                                    searchIcon
                                    dataArray={surgeonOptions}
                                    getOptionLabel={(option) => option.label}
                                    isOptionEqualToValue={(option, value) =>
                                        option?.id === value?.id
                                    }
                                    handleInputChange={getSurgeonDropdown}
                                    size="small"
                                    fullWidth
                                />
                            </div>

                            <div className="grid grid-cols-[180px_20px_1fr] items-center gap-2">
                                <Typography fontWeight="600">
                                    Anesthetist
                                </Typography>

                                <Typography>:</Typography>

                                <SearchDropdown
                                    control={control}
                                    name="anesthetist"
                                    label="Anesthetist"
                                      placeholder="Anesthetist"
                                    options={anesthetistOptions}
                                    isClearable
                                    searchIcon
                                    dataArray={anesthetistOptions}
                                    getOptionLabel={(option) => option.label}
                                    isOptionEqualToValue={(option, value) =>
                                        option?.id === value?.id
                                    }
                                    handleInputChange={getAnesthetistDropdown}
                                    size="small"
                                    fullWidth
                                />
                            </div>


                            <div className="grid grid-cols-[180px_20px_1fr] items-start gap-2">
                                <Typography fontWeight="600">
                                    Remark
                                </Typography>

                                <Typography>:</Typography>

                                <Controller
                                    name="remark"
                                    control={control}
                                    render={({ field }) => (
                                        <TextField
                                            {...field}
                                            label="Remark"
                                            multiline
                                            rows={2}
                                            fullWidth
                                            size="small"
                                        />
                                    )}
                                />
                            </div>

                        </div>
                    </div>


                    <div className="border rounded-md bg-white">
                        <div className="bg-lime-200 text-sm font-semibold px-4 py-2 rounded-t-md ">
                            Handover Details
                        </div>

                        <div className="space-y-3 p-4">

                            <div className="grid grid-cols-[180px_20px_1fr] items-center gap-2 py-1">
                                <Typography fontWeight="600">
                                    Handover To
                                </Typography>

                                <Typography>:</Typography>

                                <SearchDropdown
                                    control={control}
                                    name="handoverTo"
                                    label="Handover To"
                                     placeholder="Handover To"
                                    options={handoverToOptions}
                                    isClearable
                                    searchIcon
                                    dataArray={handoverToOptions}
                                    getOptionLabel={(option) => option.label}
                                    isOptionEqualToValue={(option, value) =>
                                        option?.id === value?.id
                                    }
                                    handleInputChange={getHandoverToDropdown}
                                    size="small"
                                    fullWidth
                                />
                            </div>

                            <div className="grid grid-cols-[180px_20px_1fr] items-center gap-2 py-1">
                                <Typography fontWeight="600">
                                    Handover By
                                </Typography>

                                <Typography>:</Typography>

                                <SearchDropdown
                                    control={control}
                                    name="handoverBy"
                                    label="Handover By"
                                      placeholder="Handover By"
                                    options={handoverByOptions}
                                    isClearable
                                    searchIcon
                                    dataArray={handoverByOptions}
                                    getOptionLabel={(option) => option.label}
                                    isOptionEqualToValue={(option, value) =>
                                        option?.id === value?.id
                                    }
                                    handleInputChange={getHandoverByDropdown}
                                    size="small"
                                    fullWidth
                                />
                            </div>

                            <div className="grid grid-cols-[180px_20px_1fr] items-center gap-2">
                                <Typography fontWeight="600">
                                    Time
                                </Typography>

                                <Typography>:</Typography>

                                <TimePickerFieldNew
                                    control={control}
                                    name="handoverTime"
                                    label="Time"
                                    textFieldProps={{
                                        size: "small",
                                        fullWidth: true,
                                    }}
                                />
                            </div>

                            <div className="grid grid-cols-[180px_20px_1fr] items-center gap-2">
                                <Typography fontWeight="600">
                                    Date
                                </Typography>

                                <Typography>:</Typography>

                                <DatePickerField
                                    control={control}
                                    name="handoverDate"
                                    label="Date"
                                    inputFormat="dd-MM-yyyy"
                                    textFieldProps={{
                                        size: "small",
                                        fullWidth: true,
                                    }}
                                />
                            </div>

                        </div>
                    </div>

                </div>

                <div className="flex justify-end gap-3 mt-6">
                    <Button
                        variant="outlined"
                        color="error"
                        onClick={() => reset()}
                        sx={{
                            textTransform: "none",
                        }}
                    >
                        Reset
                    </Button>

                    <Button
                        variant="contained"
                        onClick={handleSubmit(handleSubmitClick)}
                        sx={{
                            backgroundColor: "#22c55e",
                            color: "#fff",
                            textTransform: "none",
                            fontWeight: 500,
                            px: 2,
                        }}
                    >
                        {isUpdate ? "Update" : "Submit"}
                    </Button>
                </div>

            </Box>

            <Backdrop
                sx={{
                    color: "#fff",
                    zIndex: 9999,
                }}
                open={loading}
            >
                <CircularProgress color="inherit" />
            </Backdrop>

            <ConfirmationModal
                confirmationOpen={openPost}
                confirmationHandleClose={handleClosePost}
                confirmationSubmitFunc={addRecord}
                confirmationLabel="Confirmation"
                confirmationMsg="Are you sure you want to submit this record ?"
                confirmationButtonMsg="Confirm"
            />
        </div >
    );
}